import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { PoseidonAgentMemoryFormBase } from '../../FormBases/PoseidonAgentMemoryFormBase/PoseidonAgentMemoryFormBase';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用のPoseidon Agent Memoryのフォームです。
 */
export const PoseidonAgentMemoryForm: FC<Props> = ({ register, error }) => (
  <FormControl isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <Box pl="40px">
        <FormLabel>- Poseidon Agent Memory</FormLabel>
      </Box>
      <PoseidonAgentMemoryFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
